"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _GoodFiltersAndPage = _interopRequireDefault(require("./GoodFiltersAndPage"));

var _default = [_GoodFiltersAndPage.default.LIMIT, _GoodFiltersAndPage.default.PAGE];
exports.default = _default;
module.exports = exports.default;